import {isOffline} from "./configService";
import imageUrlBuilder from "@sanity/image-url";
import {client} from "./sanityService";
const builder = imageUrlBuilder(client)

export function urlFor(source) {
  return builder.image(source)
}

export const previewUrlForVideo = (video) =>  {
  if (!video) {
    return ""
  }
  if (isOffline()) {
    return `resources/images/generated/${video.tutorialImage.path}`
  } else {
    return urlFor(video.tutorialImage)
  }
}

export const previewUrlForCategory = (category) => {
  if (isOffline()) {
    return `resources/images/generated/${category.image.path}`
  } else {
    return urlFor(category.image)
  }
}

export const previewUrlForPlaylist = (playlist) => {
  if (isOffline()) {
    return `resources/images/generated/${playlist.thumbnail.path}`
  } else {
    return urlFor(playlist.thumbnail)
  }
}

